import React from 'react';
import styles from './PasswordRequirements.module.scss';
import { useI18n } from '../../../../../../data/hooks/i18nHooks';

function PasswordRequirements(props) {
    const {className=''} = props,
        i18n = useI18n(),
        requirements = i18n['message.password-requirements'].split('\n');

    return (
        <div className={[className, styles.PasswordRequirements].join(' ')}>
            {requirements.map((r, i) => (
                <p key={i}>{r}</p>
            ))}
        </div>
    );
}

export default PasswordRequirements;
